// Configuración centralizada de colores y tema
// Personalización con Paleta Corporativa Laooal Dental
// Versión: DISEÑO VISUAL v1.0

export const ThemeConfig = {
    colors: {
        // Paleta Corporativa Laooal
        primary: "#4E6566",        // Verde Oliva Primario (logo, headers, elementos principales)
        secondary: "#6ca1da",      // Azul-Púrpura (profesionalismo, tecnología)
        accent: "#9A9943",         // Oro Corporativo (CTA, destacados)
        error: "#dc3545",          // Rojo (errores)
        warning: "#ff9800",        // Naranja (alertas, atención)
        info: "#0093e9",           // Cian (información)
        success: "#28a745",        // Verde (éxito, confirmaciones)
        background: "#F5F5F5",     // Fondo claro Laooal
    },
    gradients: {
        // Gradientes corporativos Laooal
        primary: "linear-gradient(118deg, #9A9943, #9A9943)",        // Azul-Púrpura principal
        loginCard: "linear-gradient(90deg, #4E6566, #6F8586, #9A9943)", // Degradado corporativo login
    },
    kanban: {
        // Estados Kanban con colores Laooal
        todo: "#dc3545",            // Rojo para pendiente
        inProgress: "#ff9800",      // Naranja para en progreso
        done: "#28a745",            // Verde para completado
        backlog: "#7A8A8B",         // Texto suave para backlog
        testing: "#0093e9"          // Cian para testing
    },
    calendar: {
        // Estados del calendario con brand Laooal
        work: "#4E6566",            // Verde primario para trabajo
        personal: "#9A9943",        // Oro para personal
        meeting: "#6ca1da",         // Azul para reuniones
        event: "#a664e2"            // Púrpura para eventos
    }
};
